module.exports = __webpack_public_path__ + "static/img/complete.4948929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/complete.png
// module id = 7tBf
// module chunks = 0